import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { useState, useEffect, useRef, useCallback } from "react";
import "./editTable.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Modal } from "semantic-ui-react";
import { Box, Loader } from "tabler-icons-react";
import {
  Entities,
  EntityVeiwMapping,
} from "../../../../../configurations/ViewAndEdit";
import {
  outletMetaData,
  updateType,
  searchPropsType,
} from "../../../../../features/editAndView/ViewAndEditType";
import {
  usePortalTranslation,
  TranslationEnum,
} from "../../../../../providers/TranslationProvider";
import { DomainValue } from "../../../../../services/mdmService/types";
import { fetchAndDownloadReport } from "../../../../../services/reportService";
import {
  getAdditionalData,
  getAllEntityMetaData,
  resetPassword,
  resetStatus,
  downloadMasterDataReport,
  donwloadReportWithStatus,
} from "../../../../../services/userService";
import { genericFilterType } from "../../../../../stateManagement/reducers/genericFilterReducer";
import store from "../../../../../stateManagement/store";
import { popupType } from "../../../../../types/types";
import BackButton from "../../../../Buttons/BackButton/BackButton";
import GenericFilters from "../../../../genericFilters/genericFilters";
import GenericViewAndEditModal from "../../../../ouletModal/GenericViewAndEditModal";
import OutletModal from "../../../../ouletModal/OutletModal";
import { ConfirmationPopUp } from "../../../../popup/confirmationPopUp";
import DownloadLoader from "../../../../popup/downloadLoader";
import { GenericPopUp } from "../../../../popup/genericPopUp";
import ProductModal from "../../../../productModal/ProductModal";
import {
  ColumnHeader,
  ModifiedData,
  productMetaData,
} from "../../../../productModal/ProductModalTypes";
import RenderSvg from "../../../../renderSvg/RenderSvg";
import UserModal from "../../../../userModal/UserModal";
import WDModal from "../../../../userModal/WDModal";
import { modelDataType } from "../../../../userModal/userModalType";
import { Tab } from "../../../../ouletModal/OutletModalTypes";
import { GenericTable } from "../../../../genericTable/GenericTable";
import { Dialog, DialogContent, Pagination } from "@mui/material";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

interface EditTableProps {
  selectedMaster?: DomainValue;
  handleScreenSwitch: (screen: "default" | "logs" | "edit") => void;
  headingTitle: string;
}

export const EditTable = (props: EditTableProps) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON = "commonPortal";
  const entity = props.selectedMaster?.entity as Entities;
  const {
    tableHeaders,
    modalConfig,
    exportConfig,
    searchEnabledColumnsConfig,
    userNameKey,
  } = props?.selectedMaster || {};
  const navigate = useNavigate();
  const designation = props.selectedMaster?.designation;
  const mdmId = props.selectedMaster?.id;
  const configuration = EntityVeiwMapping.filter((viewEntityMetaData) => {
    return entity === viewEntityMetaData.entity;
  });
  const [columnHeaders, setColumnHeaders] = useState<ColumnHeader[]>(
    configuration.length > 0 ? configuration[0].columns : []
  );
  const [activeDisabled, setactiveDisabled] = useState<String>("");
  const endPoint = configuration.length
    ? configuration[0].endPoint.getAllData
    : "";
  const [outletNewModal, setOutletNewModal] = useState<Boolean>(false);
  const [mdmModalConfig, setMDMModalConfig] = useState<Tab[]>([]);
  const [openReportModal, setOpenReportModal] = useState<boolean>(false);
  const [resetFiltersFlag, setResetFiltersFlag] = useState<boolean>(false);

  const modifiedData = {
    ...configuration[0],
    columns: columnHeaders,
    ...(tableHeaders && tableHeaders?.Actions
      ? { Actions: tableHeaders?.Actions }
      : configuration[0]?.Actions),
    ...(activeDisabled ? { active: activeDisabled } : {}),
  } as ModifiedData;

  useEffect(() => {
    if (!entity) {
      navigate("/dashboard/mdm");
      return;
    }
    if (
      mdmId === "wdViewAndEdit" ||
      mdmId === "OutletDetails" ||
      mdmId === "ProductDetails"
    ) {
      if (tableHeaders) {
        setColumnHeaders(tableHeaders.columns);
        setactiveDisabled(tableHeaders.active);
      }
      if (modalConfig) {
        setOutletNewModal(true);
        setMDMModalConfig(modalConfig);
      }
    }
    getTableRows(endPoint, undefined, undefined, undefined, designation);

    const end =
      (configuration[0]?.endPoint as Record<string, string | undefined>) ??
      null;

    const additionalCachedData = async () => {
      if (!end) {
        return;
      }
      if (configuration[0] && configuration[0].additinalData) {
        return await Promise.all(
          configuration[0].additinalData.map(async (currentValue) => {
            const response = await getAdditionalData(end[currentValue]);

            return response.data.features
              ? response.data.features
              : response.data;
          })
        );
      }
    };
    const getPreRequireddata = async () => {
      const preRequiredData = await additionalCachedData();
      setAdditionalCached(preRequiredData);
    };
    getPreRequireddata();
  }, []);

  const [loader, setLoader] = useState(true);

  const [openModal, toggleModal] = useState(false);

  const [modelData, setModelData] = useState<
    modelDataType | productMetaData | outletMetaData
  >();

  const [rows, setRows] = useState([]);

  const [pages, setPages] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);

  const [searchedValue, setSeacrhedvalue] = useState("");

  const [timerId, setTimerId] = useState<NodeJS.Timeout | null>(null);

  const [additionalCached, setAdditionalCached] = useState<any[] | undefined>(
    []
  );

  const [genericModalState, setGenericModalState] = useState(false);
  const [genericModalMessage, setGenericModalSMessage] = useState("");
  const [genericModaltype, setGenericModalType] = useState<popupType>("Error");

  const [confirmationPopUp, setConfirmationPopUp] = useState(false);

  const [popUpMessage, setPopUpMessage] = useState<string>("");

  const popUpSuccessMethod = useRef<() => void>();

  const mdmFiltersRef = useRef<genericFilterType>({});

  const onApplyClick = async () => {
    setLoader(true);
    setSeacrhedvalue("");
    const globalFilterValues = store.getState()?.genericFilter;
    mdmFiltersRef.current = globalFilterValues;
    getTableRows(
      endPoint,
      1,
      undefined,
      undefined,
      designation,
      globalFilterValues
    );
  };
  const lastApiCallTime = useRef<number>(0);

  const getTableRows = async (
    endPoint: string,
    currentPage: number = 1,
    searchedValue?: string,
    searchedColums?: string[],
    designation?: string,
    globalFilters?: genericFilterType
  ) => {
    try {
      const currApiCallTime = Date.now();
      setLoader(true);
      if (currApiCallTime >= lastApiCallTime.current) {
        lastApiCallTime.current = currApiCallTime;
      }
      const response = await getAllEntityMetaData(
        endPoint,
        currentPage - 1,
        searchedValue,
        searchedColums,
        designation,
        globalFilters
      );
      if (currApiCallTime >= lastApiCallTime.current) {
        setRows(response?.data?.features);
        setPages(response?.data?.totalPage);
      }
      if (currApiCallTime === lastApiCallTime.current) {
        setLoader(false);
      }
    } catch (error) {
      setGenericMetaData("Something went wrong", "Error", true);
      setRows([]);
      setLoader(false);
    }
  };
  const debouncingTheSearch = useCallback(
    (value: string) => {
      // debouncing code
      if (timerId) {
        clearTimeout(timerId);
      }
      const newTimerId = setTimeout(() => {
        setLoader(true);
        setCurrentPage(1);
        getTableRows(
          endPoint,
          1,
          value,
          searchedColumns,
          designation,
          mdmFiltersRef.current
        );
      }, 400); // debounce time in milliseconds
      setTimerId(newTimerId);
    },
    [searchedValue, timerId]
  );

  const Actions = configuration?.length ? modifiedData.Actions : [];
  const searchedColumns = searchEnabledColumnsConfig
    ? searchEnabledColumnsConfig
    : configuration.length
    ? modifiedData.searchEnabledColumns
    : [];
  const columns: GridColDef[] = configuration.length
    ? modifiedData.columns.map((columnsMetaData) => {
        return {
          disableColumnMenu: true,
          field: columnsMetaData.mappedValue,
          headerName: translate(
            entity,
            columnsMetaData.headerName
          ).toUpperCase(),
          sortable: false,
          minWidth: 100,
          flex: 1,
          headerAlign: "center",
          align: "center",
          valueGetter: (params: GridRenderCellParams) => {
            if (columnsMetaData.findIn) {
              if (params.field === "portalAccess") {
                const isAdmin =
                  params.row.roles.find(
                    (role: { name: string }) =>
                      role.name === "ROLE_LOGIN_ACCESS"
                  ) !== undefined;
                if (isAdmin) {
                  return "Y";
                } else {
                  return "N";
                }
              }
              if (params.field === "wdDistrict") {
                const metaFindIn = columnsMetaData.findIn;
                var DL = params.row[metaFindIn].split(">");
                if (DL[1]) {
                  return DL[1];
                }
              }
              if (params.field === "wdBranch") {
                const metaFindIn = columnsMetaData.findIn;
                var DL = params.row[metaFindIn].split(">");
                if (DL[0]) {
                  return DL[0];
                }
              }
            }
            const field = params.field;
            let columnValue: any;
            if (field.includes(".")) {
              const filedArrays = field.split(".");
              columnValue = params.row;
              filedArrays?.forEach((subStringpart: string) => {
                if (!columnValue) {
                  return;
                }
                columnValue = columnValue[subStringpart];
              });
              return columnValue;
            }
            if (params.field === "discontinuedSku") {
              if (params.row.activeStatus === "active") {
                return "N";
              } else {
                return "Y";
              }
            }

            return params.row[field];
          },
        };
      })
    : [];
  function resetStatusEditBody(
    modelData: modelDataType | productMetaData | outletMetaData
  ) {
    switch (entity) {
      case "User": {
        const changeDataType = modelData as modelDataType;
        const dataObj: updateType = {
          loginId: changeDataType?.loginId,
          userAccountId: changeDataType?.userAccountId,
          activeStatus:
            modelData.activeStatus === "active" ? "inactive" : "active",
        };
        return dataObj;
      }
      case "ProductDetails": {
        const changeDataType = modelData as productMetaData;
        const dataObj: productMetaData = {
          ...changeDataType,
          activeStatus:
            changeDataType.activeStatus === "active" ? "inactive" : "active",
        };
        return dataObj;
      }
      case "OutletDetails": {
        modelData = modelData as outletMetaData;
        const dataObj: outletMetaData = {
          outletCode: modelData.outletCode,
          activeStatus:
            modelData.activeStatus === "active" ? "inactive" : "active",
          activeStatusReason:
            modelData.activeStatus +
            " by " +
            JSON.parse(localStorage.authContext).user.loginId,
          ...(userNameKey && {
            userName: {
              loginId: modelData.userName,
              activeStatus:
                modelData.activeStatus === "active" ? "inactive" : "active",
            },
          }),
        };
        return dataObj;
      }
    }
  }

  const generateMesaage = (
    modelData: modelDataType | productMetaData | outletMetaData
  ) => {
    switch (entity) {
      case "User": {
        const changeDataType = modelData as modelDataType;
        return changeDataType.name;
      }
      case "ProductDetails": {
        const changeDataType = modelData as productMetaData;
        return changeDataType.skuDescription;
      }

      case "OutletDetails": {
        const changeDataType = modelData as outletMetaData;
        return changeDataType.outletCode;
      }
    }
  };

  const setGenericMetaData = (
    message: string,
    type: popupType,
    state: boolean
  ) => {
    setGenericModalState(state);
    setGenericModalSMessage(message);
    setGenericModalType(type);
  };

  const updateConfirmationPopData = (
    message: string,
    methodHelper: () => void
  ) => {
    popUpSuccessMethod.current = methodHelper;
    setPopUpMessage(message);
  };

  const setPasswordToDefault = async (modelData: modelDataType | undefined) => {
    try {
      if (modelData && modelData.loginId) {
        const response = await resetPassword(modelData.loginId);
        if (response.status === 200) {
          setGenericMetaData(
            translate(
              TranslationEnum.common_portal,
              "Successfully updated password"
            ),
            "Success",
            true
          );
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      setGenericMetaData(
        "Some Error occured while Updating the password",
        "Error",
        true
      );
    }
  };

  const changeStatusFunction = async (
    modelData: modelDataType | productMetaData | outletMetaData
  ) => {
    try {
      switch (entity) {
        case "User": {
          const requestBody = resetStatusEditBody(modelData);
          const response = await resetStatus("/users", requestBody);
          return response;
        }
        case "ProductDetails": {
          const requestBody = resetStatusEditBody(modelData);
          const response = await resetStatus("/products", requestBody);
          return response;
        }
        case "OutletDetails": {
          const requestBody = resetStatusEditBody(modelData);
          const response = await resetStatus(
            "/outletDetails/update",
            requestBody
          );
          return response;
        }
      }
    } catch (error) {
      return error;
    }
  };

  const updateStatus = async (
    modelData: modelDataType | productMetaData | outletMetaData
  ) => {
    try {
      if (modelData) {
        const response = await changeStatusFunction(modelData);
        if (response.status === 200 || response.status === 201) {
          setGenericMetaData("Data Updated Successfully", "Success", true);
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      setGenericMetaData(
        "Some Error occured while Updating the Status",
        "Error",
        true
      );
    }
  };

  if (Actions.includes("Product Image")) {
    columns.push({
      field: "productImage",
      headerName: "Product Image",
      sortable: false,
      minWidth: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.blobKey ? (
          <img src={params.row.blobKey} alt="" style={{ height: 50 }} />
        ) : (
          <p>{translate(TranslationEnum.common_portal, "No Image")}e</p>
        );
      },
    });
  }

  if (Actions.includes("Edit")) {
    columns.push({
      field: "Edit",
      headerName: translate(
        TranslationEnum.common_portal,
        "Edit"
      ).toUpperCase(),
      sortable: false,
      minWidth: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <div
            className="studio-edit-button"
            onClick={() => {
              setModelData(params.row);
              toggleModal(true);
            }}
          >
            <RenderSvg name="Reset-password" />
            <span className="studio-edit-button-text">
              {translate(TranslationEnum.common_portal, "Edit")}
            </span>
          </div>
        );
      },
    });
  }

  if (Actions.includes("ChangeStatus")) {
    columns.push({
      field: "Change Status",
      headerName: translate(
        TranslationEnum.common_portal,
        "Change Status"
      ).toUpperCase(),
      sortable: false,
      minWidth: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => {
        if (params.row.activeStatus === "active") {
          return (
            <div
              className="studio-edit-button"
              onClick={() => {
                setModelData(params.row);
                setConfirmationPopUp(true);
                updateConfirmationPopData(
                  translate(
                    TranslationEnum.common_portal,
                    "Are you sure want to Deactivate {name}",
                    { name: generateMesaage(params.row) ?? "" }
                  ),
                  () => {
                    updateStatus(params.row);
                  }
                );
              }}
            >
              <RenderSvg name="Deactivate" />
              <span className="studio-edit-button-text">
                {translate(TranslationEnum.common_portal, "Deactivate")}
              </span>
            </div>
          );
        } else {
          return (
            <div
              className={`studio-edit-button ${
                modifiedData.active === "disabled" ? "active-disabled" : ""
              }`}
              onClick={() => {
                setModelData(params.row);
                setConfirmationPopUp(true);
                updateConfirmationPopData(
                  translate(
                    TranslationEnum.common_portal,
                    "Are you sure want to Activate {name}",
                    { name: generateMesaage(params.row) ?? "" }
                  ),
                  () => {
                    updateStatus(params.row);
                  }
                );
              }}
            >
              <RenderSvg name="Activate" />
              <span className="studio-edit-button-text">
                {translate(TranslationEnum.common_portal, "Activate")}
              </span>
            </div>
          );
        }
      },
    });
  }
  if (Actions.includes("ResetPassword")) {
    columns.push({
      field: "Reset Password",
      headerName: translate(
        TranslationEnum.common_portal,
        "Reset Password"
      ).toUpperCase(),
      sortable: false,
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <div
            className="studio-edit-button"
            onClick={() => {
              setModelData(params.row);
              setConfirmationPopUp(true);
              updateConfirmationPopData(
                translate(
                  TranslationEnum.common_portal,
                  "Are you sure want to reset password for {name}",
                  { name: generateMesaage(params.row) ?? "" }
                ),
                () => {
                  setPasswordToDefault(params.row);
                }
              );
            }}
          >
            <RenderSvg name="Reset-password" />
            <span className="studio-edit-button-text">
              {translate(TranslationEnum.common_portal, "Reset Password")}
            </span>
          </div>
        );
      },
    });
  }

  const exportFunctionalityOFMDM = async () => {
    setOpenReportModal(true);
    const response = await downloadMasterDataReport(
      entity,
      exportConfig,
      mdmFiltersRef.current
    );
    if (response.status === 200) {
      console.log(openReportModal);
      if (exportConfig) {
        donwloadReportWithStatus(response.data.id, setOpenReportModal);
      } else {
        const data = response.data.features;
        if (data && data.length > 0) {
          await fetchAndDownloadReport(data?.[0]?.payload?.url);
          setOpenReportModal(false);
        } else {
          setGenericMetaData(
            "Looks like master data report has not been generated yet",
            "Error",
            true
          );
          setOpenReportModal(false);
        }
      }
    } else {
      setOpenReportModal(false);
      setGenericMetaData(
        "Some Error occured while downloading the master report",
        "Error",
        true
      );
    }
  };

  const searchProps: searchPropsType[] =
    configuration.length !== 0
      ? configuration[0].columns.map((columnsMetaData) => {
          return {
            searchKey: columnsMetaData.mappedValue,
            searchFilter: (a: string, b: string) => {
              return a === b;
            },
          };
        })
      : [];

  const loadModel = (entity: string, id?: string) => {
    switch (entity) {
      case "User":
        if (id === "wdViewAndEdit") {
          return (
            <WDModal
              close={() => toggleModal(false)}
              modelData={modelData as modelDataType}
              setGenericMetaData={setGenericMetaData}
              getTableRows={getTableRows}
            />
          );
        } else {
          return (
            <UserModal
              close={() => toggleModal(false)}
              modelData={modelData as modelDataType}
              setGenericMetaData={setGenericMetaData}
              getTableRows={getTableRows}
            />
          );
        }
      case "ProductDetails":
        if (outletNewModal) {
          return (
            <GenericViewAndEditModal
              close={() => toggleModal(false)}
              modelData={modelData as outletMetaData}
              setGenericMetaData={setGenericMetaData}
              mdmModalConfig={mdmModalConfig}
              productType={true}
            />
          );
        } else {
          return (
            <ProductModal
              close={() => {
                toggleModal(false);
              }}
              modelData={modelData as productMetaData}
              setGenericMetaData={setGenericMetaData}
              getTableRows={getTableRows}
              additionaCachedData={additionalCached}
            />
          );
        }
      case "OutletDetails":
        if (outletNewModal) {
          return (
            <GenericViewAndEditModal
              close={() => toggleModal(false)}
              modelData={modelData as outletMetaData}
              setGenericMetaData={setGenericMetaData}
              getTableRows={getTableRows}
              mdmModalConfig={mdmModalConfig}
            />
          );
        } else {
          return (
            <OutletModal
              close={() => toggleModal(false)}
              modelData={modelData as outletMetaData}
              setGenericMetaData={setGenericMetaData}
              getTableRows={getTableRows}
              additionaCachedData={additionalCached}
            />
          );
        }
    }
  };

  return (
    <>
      <div className="app-bar">
        <div className="back-button">
          <Button
            onClick={() => props.handleScreenSwitch("default")}
            variant="text"
            sx={{ fontSize: "16px", color: "#434343" }}
          >
            ←
          </Button>{" "}
          <span className="title">{props.headingTitle}</span>
        </div>

        <div className="search-download">
          <div className="search-input-container">
            <input
              type="text"
              className="search-input"
              placeholder={translate(TranslationEnum.common_portal, "Search")}
              value={searchedValue}
              onChange={(e) => {
                setSeacrhedvalue(e.target.value);
                debouncingTheSearch(e.target.value);
              }} // Trigger search on Enter key
            />
            <div className={`search-icon active`}>
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                color="white"
                fontSize={"10px"}
              />
            </div>
          </div>{" "}
          <button
            className="download-button-bar"
            onClick={() => {
              setConfirmationPopUp(true); // Show confirmation popup
              updateConfirmationPopData(
                "Are you sure you want to download master data?", // Confirmation message
                () => {
                  exportFunctionalityOFMDM(); // Trigger export functionality
                }
              );
            }}
          >
            <span
              className="download-icon"
              style={{ fontSize: "14px", color: "white" }}
            >
              ↓
            </span>{" "}
            Download
          </button>
        </div>
      </div>

      <ConfirmationPopUp
        openConfirmModal={confirmationPopUp}
        message={popUpMessage}
        setOpenConfirmModal={() => {
          setConfirmationPopUp(false);
        }}
        successMethod={popUpSuccessMethod.current}
      />

      <GenericPopUp
        type={genericModaltype}
        message={genericModalMessage}
        openGenericModal={genericModalState}
        setOpenGenericModal={() => {
          setCurrentPage(1);
          genericModaltype === "Success" &&
            getTableRows(endPoint, 1, undefined, undefined, designation);
          setResetFiltersFlag(!resetFiltersFlag);
          mdmFiltersRef.current = {};
          setGenericModalState(false);
        }}
      />
      {loader ? (
        <Loader />
      ) : (
        <div className="table-style">
          <GenericTable
            searchedProps={searchProps}
            table={{
              rows,
              columns,
              isOfflineSearchEnable: false,
              hideFooter: true,
            }}
          />
          <div className="pagination">
            <Pagination
              count={pages}
              variant="outlined"
              shape="rounded"
              color={"primary"}
              onChange={async (event, value) => {
                setCurrentPage(value);
                setLoader(true);
                await getTableRows(
                  endPoint,
                  value,
                  searchedValue,
                  searchedColumns,
                  designation,
                  mdmFiltersRef.current
                );
              }}
              page={currentPage}
            />
          </div>
          {openReportModal ? (
            <DownloadLoader
              message={"Your report will be downloaded shortly."}
              openReportModal={openReportModal}
              setOpenReportModal={setOpenReportModal}
            />
          ) : null}
        </div>
      )}
      <Dialog
        open={openModal}
        onClose={() => toggleModal(false)}
        PaperProps={{
          style: {
            background: "transparent",
            boxShadow: "none",
          },
        }}
      >
        <div
          style={{
            // height: "600px",
            // width: "400px",
            height: "100vh",
            width: "100vw",
            // overflow: "hidden",
            // background: "transparent",
          }}
        >
          {loadModel(entity, mdmId)}
        </div>
      </Dialog>
    </>
  );
};
